<template>
  <div>
    <div ref="echarts" style="height: 400px; width: 100%;"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  data() {
    return {

    };
  },
  computed: {
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      const chartDom = this.$refs.echarts;
      const myChart = echarts.init(chartDom);
      const option = {
    title: {
        text: '',
        left: 'center'
    },
    tooltip: {
        trigger: 'axis',
        padding: [2, 10],
        textStyle: {
            fontSize: 16
        }
    },
    xAxis: {
        type: 'category',
        splitLine: {
            show: false
        },
        axisLine: {
            lineStyle: {
                width: 3
            }
        },
        axisTick: {
            show: true,
            alignWithLabel: true,
            lineStyle: {
                width:3
            }
        },
        axisLabel: {
            rotate: 45,
            fontWeight: "bold",
            formatter: function(value) {
                return value.split(" ")[1];
            }
        },
        data: ["2017-09-11 16:23:34", "2017-09-11 16:28:34", "2017-09-11 16:33:34", "2017-09-11 16:38:34", "2017-09-11 16:43:34", "2017-09-11 16:48:34", "2017-09-11 16:53:34"]
    },
    grid: {
        left: '2%',
        right: '4%',
        bottom: '4%',
        containLabel: true
    },
    visualMap: {
        show: false,
        pieces: [{
            gt: 0,
            lte: 0.9,
            color: 'red'
        },{
            gt: 1,
            lte: 1.9,
            color: 'yellow'
        }, {
            gt: 2,
            lte: 2.9,
            color: 'blue'
        }],
        seriesIndex: 0
    },
    yAxis: {
        type: 'value',
        name: 'M',
        splitLine: {
            show: false
        },
        axisLine: {
            lineStyle: {
                width: 3,
                color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                        offset: 0,
                        color: 'red'
                    }, {
                        offset: 1,
                        color: 'blue'
                    }],
                    globalCoord: false // 缺省为 false
                }
            }
        },
        axisTick: {
            lineStyle: {
                width: 3
            }
        },
        axisLabel: {
            fontWeight: "bold",
        }
    },
    series: [{
          type: 'line',
          symbol: 'circle',
          symbolSize: 10,
          smooth: true,
          itemStyle: {
              normal: {
                  color: 'rgb(103, 99, 99)',
                  shadowBlur: 2,
                  shadowColor: "rgba(0, 0, 0, .12)",
                  shadowOffsetX: 2,
                  shadowOffsetY: 2
              }
          },
          lineStyle: {
              normal: {
                  width: 3,
                  shadowColor: 'rgba(0,0,0,0.4)',
                  shadowBlur: 10,
                  shadowOffsetX: 4,
                  shadowOffsetY: 10
              }
          },
          data: [1, 1,null, 2, 2, 2,null],
          }, ]
      };
      myChart.setOption(option);
        const dateRange = [
            { start: '2017-09-11 16:20:00', end: '2017-09-11 16:30:00', color: 'red' ,	"eraType": 0,},
            { start: '2017-09-11 16:30:00', end: '2017-09-11 16:40:00', color: 'blue' ,"eraType": 0,},
            { start: '2017-09-11 16:40:00', end: '2017-09-11 16:50:00', color: 'green' ,"eraType": 2,},
            { start: '2017-09-11 16:50:00', end: '2017-09-11 17:00:00', color: 'yellow' ,"eraType": 1,}
        ];
    },
  }
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
}

li {
  margin: 5px 0;
}
</style>


// WEBPACK FOOTER //
// src/components/productlist/ceshixiangmu.vue